export enum VOLUME_ALLOCATION {
  LastMonth = "Last Month Allocation",
  Minimum = "Minimum Allocation",
  LatestQuote = "Latest Quote",
}

export enum USER_ROLE {
  Manager = "Manager",
  Lead = "Lead",
}

export enum APPROVAL_STATUS {
  NoChange = "No Change",
  Requested = "Approval Requested",
  Pending = "Pending Approval",
  Self = "Self Approved",
  Approved = "Approved",
}

export enum Error_MESSAGE {
  CostTooLow = "Value entered is less than 30% of estimated business cost ! Please enter a higher value",
  CostTooHigh = "Value entered is more than 30% of estimated business cost ! Please enter a lower value.",
  CostLessThanVendorQuote = "Value entered is below quotation and may lead to negative PPV. Please enter a higher value !",
  AllocationTooLow = "Value entered cannot be 30% lower than Projected Release ! Please enter a higher value",
  AllocationTooHigh = "Value entered cannot be 30% more than Projected Release ! Please enter a lower value.",
}

export enum Module_Name {
  upcoming_negotiations = "Negotiations & Allocations",
  business_cost = "Business Cost Setting",
  compliance_monitoring = "Compliance Monitoring",
  nia_opportunity = "NIA Opportunity",
}

export enum KPI_Name {
  ytd_spend = "YTD Spend (Stock)",
  ytd_volume = "YTD Purchase Volume (Stock)",
  ytd_sales = "YTD Sales (Stock)",
  yoy_spend = "YoY Spend",
  yoy_volume = "YoY Purchase Volume",
  yoy_sales = "YoY Sales",
}

export enum CD_Routes {
  upcoming_negotiations = "/quote-assessment",
  business_cost = "/cost-setting",
  compliance_monitoring = "/cost-compliance",
  nia_opportunity = "/nia-opportunity",
}

export const PriotiyValue: any = [
  { label: "Priority 1", value: 1 },
  { label: "Priority 2", value: 2 },
  { label: "Priority 3", value: 3 },
  { label: "Priority 4", value: 4 },
];

export const whiteLabelConstansts = {
  EXPANDED_COLUMNS: [
    "Product Type",
    "Item Type",
    "Division",
    "Cases/year (prior 52 weeks)",
    "Revenue/year (prior 52 weeks)",
    "Rule Type",
    "Rule",
    "Current CFP",
    "Variation from NBE",
    "Avg. Recommended CFP",
    "Avg. Recommended Price Change",
    "Loaded Opportunity($)",
    "Status",
    "Actions",
  ],
  COLLAPSED_COLUMNS: [
    "Product Type",
    "Cases/year (prior 52 weeks)",
    "Revenue/year (prior 52 weeks)",
    "Loaded Opportunity($)",
    "Status",
  ],
  COMMON_COLUMNS: [
    "Product Type",
    "Item Type",
    "Division",
    "Cases/year (prior 52 weeks)",
    "Revenue/year (prior 52 weeks)",
    "Avg. Recommended Price Change",
    "Loaded Opportunity($)",
    "Status",
    "Actions",
  ],
};

export const customerProfitabilityConstants = {
  TABS_DATA: [
    { id: "1", key: "summary", title: "Summary", tab: "Summary content" },
    { id: "2", key: "details", title: "Details", tab: "Details" },
    {
      id: "3",
      key: "breakDown",
      title: "Pricing / Margin Waterfall",
      tab: "BreakDown",
    },
  ],
};

export const ApplicationBaseUrlList = {
  marginBrain:
    "https://wdadvantage-marginbrain-eugfe5d5e4cvfqe9.a01.azurefd.net",
  catman: "https://wdadvantage-catman-c8bvcdf9bjewh0da.a01.azurefd.net",
  demandBrain: "https://demandbrain-ep-g6f9c8dudga8fwas.a01.azurefd.net",
  rebateoptimizer:
    "https://wdadvantage-rebateoptimizer-pe-ajhwh8e5f2f5ffbp.a01.azurefd.net",
  consolidated:
    "https://wdadvantage-rebateoptimizer-pe-ajhwh8e5f2f5ffbp.a01.azurefd.net",
};

type MainNavbarMenuType = {
  id: number;
  title: string;
  route?: string;
  active?: boolean;
  subMenu?: MainNavbarSubMenuType[];
};

type MainNavbarSubMenuType = {
  id: number;
  title: string;
  items?: MainNavbaritemSubMenu[];
  route?: string;
  url?: string;
};

type MainNavbaritemSubMenu = {
  id: number;
  title: string;
  url: string;
};

export const MainNavbarMenu: MainNavbarMenuType[] = [
  {
    id: 1,
    title: "Home",
    route: "/",
  },
  {
    id: 2,
    title: "Alerts",
    route: "/alerts",
  },
  {
    id: 3,
    title: "Performance Metrics",
    route: "/performance-metrics",
  },
  {
    id: 4,
    title: "Planning",
    subMenu: [
      {
        id: 2,
        title: "Forecast Alerts",
        items: [
          {
            id: 1,
            title: "High Over-Forecasting",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighOverForecasting`,
          },
          {
            id: 2,
            title: "High Under-Forecasting",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighUnderForecasting`,
          },
          {
            id: 3,
            title: "Low Forecast Accuracy",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=LowForecastAccuracy`,
          },
          {
            id: 4,
            title: "High Outlier Correction",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighOutlierCorrection`,
          },
          {
            id: 5,
            title: "Volatile Forecast",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=VolatileForecast`,
          },
        ],
      },
      {
        id: 3,
        title: "Inventory Alerts",
        items: [
          {
            id: 1,
            title: "Potential Overstock",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=PotentialOverstock`,
          },
          {
            id: 2,
            title: "Potential Stockout",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=PotentialStockout`,
          },
          {
            id: 3,
            title: "Ageing Inventory",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=AgeingInventory`,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Category Management",
    subMenu: [
      {
        id: 2,
        title: "Sourcing & Strategic Supplier Negotiations",
        items: [
          {
            id: 1,
            title: "Supplier Consolidation",
            url: `${ApplicationBaseUrlList.catman}/supplier-consolidation`,
          },
          {
            id: 2,
            title: "Cost Optimization",
            url: `${ApplicationBaseUrlList.catman}/cost-optimization`,
          },
          {
            id: 3,
            title: "Rebate: Peer Benchmark",
            url: `${ApplicationBaseUrlList.catman}/opportunities`,
          },
        ],
      },
      {
        id: 3,
        title: "Assortment & Product",
        items: [
          {
            id: 1,
            title: "SKU Management",
            url: `${ApplicationBaseUrlList.catman}/sku-management`,
          },
          {
            id: 2,
            title: "Portfolio Gap",
            url: `${ApplicationBaseUrlList.catman}/portfolio`,
          },
        ],
      },
      {
        id: 4,
        title: "Commercial & Pricing",
        items: [
          {
            id: 1,
            title: "Commercial Optimization",
            url: `${ApplicationBaseUrlList.catman}/pricing`,
          },
          {
            id: 2,
            title: "Brand Cost Indexing",
            url: `${ApplicationBaseUrlList.marginBrain}/wlp`,
          },
        ],
      },
      {
        id: 5,
        title: "Category Profitability",
        items: [
          {
            id: 1,
            title: "Category Profitability",
            url: `${ApplicationBaseUrlList.catman}/profitability`,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Customer Profitability",
    active: true,
    subMenu: [
      {
        id: 2,
        title: "Customer Profitability Opportunity",
        items: [
          {
            id: 1,
            title: "Pricing",
            url: `${ApplicationBaseUrlList.marginBrain}/pricing`,
          },
          {
            id: 2,
            title: "Cost To Serve",
            url: `${ApplicationBaseUrlList.marginBrain}/cts`,
          },
        ],
      },
      {
        id: 3,
        title: "Strategic Growth",
        items: [
          {
            id: 1,
            title: "Cross Sell",
            url: `${ApplicationBaseUrlList.marginBrain}/cross-sell`,
          },
          {
            id: 2,
            title: "White Label Pricing",
            url: `${ApplicationBaseUrlList.marginBrain}/wlp`,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    title: "SPA Optimizer",
    subMenu: [
      {
        id: 1,
        title: "Overview",
        url: `${ApplicationBaseUrlList.rebateoptimizer}/#/overview`,
      },
      {
        id: 2,
        title: "Leakage Management",
        items: [
          {
            id: 1,
            title: "Leakage ID / Closeout",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/leakageManagement`,
          },
        ],
      },
      {
        id: 3,
        title: "Negotiations",
        items: [
          {
            id: 1,
            title: "Cost Intelligence",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/costIntelligence`,
          },
          {
            id: 2,
            title: "Negotiation Analytics",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/negotiationAnalytics`,
          },
        ],
      },
    ],
  },
];
